import {
  Box,
  Center,
  Flex,
  Grid,
  Skeleton,
  SkeletonText,
  Stack,
  StackDivider,
  Text,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PaymentPlan from "../component/PaymentPlan";

export default function PackagePlan() {
  let { selectedPackage } = useParams();
  const [activePackage, setActivePackage] = useState({});

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_API}packages`)
      .then((res) => {
        const activeIndex = res.data.data.findIndex(
          (currPackage) =>
            currPackage.name.toLowerCase() === selectedPackage.toLowerCase()
        );
        console.log(res.data.data[activeIndex]);
        setActivePackage(res.data.data[activeIndex]);
      })
      .catch((err) => console.log({ err }));
  }, [selectedPackage]);

  const [selectedPlan, setSelectedPlan] = useState();
  const cardBgs = ["#3981C5", "#6F5ED3", "#FFB200"];

  const selectPlan = (planPicked) => {
    let selected = planPicked;
    selected.packageName = activePackage.name;
    selected.packageId = activePackage._id;
    setSelectedPlan(selected);
  };

  const navBack = () => {
    setSelectedPlan();
  };

  return (
    <Grid
      templateColumns={["1fr", null, "33% 67%"]}
      sx={{ minHeight: "100vh", width: "100%" }}
    >
      <Box
        sx={{
          bg: "url('/images/packageplan.png')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: ["none", "none", "block"],
        }}
      ></Box>

      <Center height={"100%"}>
        {/* shows if a plan is not selected */}
        {!selectedPlan && (
          <>
            {activePackage && !Object.keys(activePackage).length > 0 && (
              <Stack sx={{ maxWidth: "450px", width: "100%" }}>
                <SkeletonText noOfLines={1} />
                <Skeleton height={86} width="100%" />
                <Skeleton height={86} width="100%" />
                <Skeleton height={86} width="100%" />
              </Stack>
            )}

            {activePackage && Object.keys(activePackage).length > 0 && (
              <Box
                sx={{
                  border: "1px solid #DAE0EA",
                  borderRadius: "4px",
                  maxWidth: "450px",
                  width: "100%",
                  textAlign: "center",
                  margin: ["0 30px", null, "0"],
                }}
              >
                <VStack
                  divider={<StackDivider borderColor="gray.500" />}
                  spacing={0.8}
                >
                  <>
                    <Flex align="center" h={86}>
                      <Text
                        sx={{
                          color: "#3981C5",
                          fontWeight: "600",
                          letterSpacing: "3px",
                          fontSize: "20px",
                          lineHeight: "25.6px",
                          textTransform: "capitalize",
                        }}
                        m={0}
                      >
                        {activePackage.name}
                      </Text>
                    </Flex>

                    {activePackage.duration.map((plan, i) => (
                      <Flex
                        justify="center"
                        hey={`duration${i}`}
                        align="center"
                        direction="column"
                        h={86}
                        w={"100%"}
                        bg={cardBgs[i]}
                        color="#ffffff"
                        sx={{ cursor: "pointer" }}
                        onClick={() => selectPlan(plan)}
                      >
                        <Text
                          sx={{
                            fontWeight: "600",
                            // letterSpacing: "3px",
                            fontSize: "20px",
                            lineHeight: "25.6px",
                          }}
                          m={0}
                        >
                          <Text as="span" sx={{ fontSize: "25px", m: 0 }}>
                            ${plan.price} /
                          </Text>
                          month
                        </Text>

                        <Text
                          sx={{
                            mt: 3,
                            fontWeight: "600",
                            letterSpacing: "3px",
                            fontSize: "20px",
                            lineHeight: "25.6px",
                            textTransform: "capitalize",
                          }}
                          m={0}
                        >
                          {plan.timeLength}
                        </Text>
                      </Flex>
                    ))}
                  </>
                </VStack>
              </Box>
            )}
          </>
        )}

        {/* shows if a plan is selected */}
        {selectedPlan && (
          <Box
            sx={{
              borderRadius: "4px",
              maxWidth: "393px",
              width: "100%",
              margin: ["0 30px", null, "0"],
            }}
          >
            <PaymentPlan selectedPlan={selectedPlan} navBack={navBack} />
          </Box>
        )}
      </Center>
    </Grid>
  );
}
